import type { Table as TableT } from '@tanstack/react-table';

import { createContext } from 'react';

export interface TiclickTableContextType<T> {
  table: TableT<T>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TableContext = createContext<TiclickTableContextType<any> | null>(
  null
);
